// extracted by mini-css-extract-plugin
export default {"emptySpace":"SpotyfyFooter_emptySpace__MMEzU","spotify":"SpotyfyFooter_spotify__9LhU-"};